import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

import classes from './guided-step-card-viewport.module.css';

export type GuidedStepCardViewportProps = Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
  children?: ReactNode;
};

/**
 * Relative, overflow-hidden region for animated guided-step cards (`flex: 1`, min height).
 * Keep {@link GuidedStepFooter} a **sibling** of this wrapper, not a child, so the footer stays fixed.
 */
export const GuidedStepCardViewport = ({
  children,
  className,
  ...rest
}: GuidedStepCardViewportProps) => (
  <div className={clsx(classes.viewport, className)} {...rest}>
    {children}
  </div>
);
